import { memo } from 'react'
import { Close } from '@icon-park/react'

import { Tokens } from '@/assets/tokens'
import { Button, Flex } from '@/components'
import { useRouting } from '@/hooks'

import { PublisherPersonsForm } from '../form/PublisherPersonsForm.component'
import { ExcelUpload } from '../uploader/ExcelUploader'
import { Divider } from '../uploader/ExcelUploader.styles'
import { DialogContainer, DialogOverlay, ModalBody, ModalHeaderContainer } from './PublisherPersonsFormModal.styles'

type Props = {
  excelFile: File | null
  setExcelFile: (file: File | null) => void
  onImport: () => void
  isImporting: boolean
}

export const PublisherPersonsFormModal = memo(Component)

function Component({ excelFile, setExcelFile, onImport, isImporting }: Props): JSX.Element | null {
  const { queryParams, changeQueryParam } = useRouting()

  if (!queryParams.addPerson) return null

  function handleClose(): void {
    changeQueryParam({ param: 'addPerson', value: undefined })
  }

  return (
    <DialogOverlay>
      <DialogContainer>
        <ModalHeaderContainer $type="row" $justify="space-between" $align="stretch" $gap={20} $fit>
          <h1>Adicionar Pessoa</h1>
          <Button.Root $variant="link" onClick={handleClose}>
            <Button.Icon value={Close} color={Tokens.ColorTextPrimary} />
          </Button.Root>
        </ModalHeaderContainer>
        <ModalBody>
          <Flex $type="column" $align="stretch" $gap={20} $fit>
            <PublisherPersonsForm onSuccess={handleClose} />

            <Divider>ou importe uma planilha</Divider>

            <ExcelUpload
              file={excelFile}
              onFileSelect={setExcelFile}
              onImport={onImport}
              isImporting={isImporting}
              acceptedFormats={['.xlsx', '.csv']}
            />
          </Flex>
        </ModalBody>
      </DialogContainer>
    </DialogOverlay>
  )
}
